export default "__VITE_ASSET__fc272522__"